<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.pagination{margin-bottom: 40px;}
/deep/.el-table-column--selection .cell{padding-right: 10px;}
/deep/.el-form-item__content .el-input {width: 400px;}
/deep/.el-form-item__label {width: 10%;margin-left: 100px;}
/deep/.el-form-item__content img {width: 148px;height: 148px;}
</style>

<template>
  <!--上传列表-->
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        stripe
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="title" label="证书标题"></el-table-column>
        <el-table-column prop="content" label="内容"> </el-table-column>
        <el-table-column label="证书图片">
          <template slot-scope="scope">
            <img :src="scope.row.thumb" width="100px" height="80px" class="head_pic"/>
          </template>
        </el-table-column>
        <el-table-column prop="authority" label="发证机构"></el-table-column>
        <el-table-column label="发证日期">
          <template slot-scope="scope">{{ (scope.row.fromtime * 1000) | formatTime() }}</template>
        </el-table-column>
        <el-table-column label="到期日期">
           <template slot-scope="scope">{{ (scope.row.totime * 1000) | formatTime() }}</template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
            <el-button type="danger" @click="deletefn(11, 47, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="btnbox">
        <el-button type="success" @click="addfn()" class="btn">添加</el-button>
        <el-button type="danger" class="elbtn delete" @click="deletesfn(11, 47)">批量删除</el-button>
      </div>
    </div>
    <!--底部分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableData.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import filters from '../../method/filter'
export default {
  mixins: [filters],
  props: ['updataID'],
  data()
  {
    return {
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      url: '',
      fileList_icon: [{url: ''}],
      fileList_img: [{url: ''}],
      form: {
        id: null,
        type: '',
        contacts: '',
        telephone: '',
        fax: '',
        email: '',
        province: '',
        city: '',
        address: '',
        icon: '',
        thumb: ''
      },
      //图标预览弹框
      dialogVisible_icon: false,
      //图标预览路径
      dialogIconUrl: '',
      uploadDisabled__icon: false,
      //图片预览弹框
      dialogVisible_Img: false,
      //图片预览路径
      dialogImageUrl: '',
      uploadDisabled_img: false,
      //————下拉数据————
      options1: [
        { value: '选项1', label: '标题', key: 'title' },
        { value: '选项2', label: '关键词', key: 'tag' },
        { value: '选项3', label: '简介', key: 'introduce' }
      ],
      //级别选项
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      //结果排序选项
      result_data: [
        { value: '选项1', label: '添加时间降序', description: 'addtime DESC' },
        { value: '选项2', label: '添加时间升序', description: 'addtime ASC' },
        { value: '选项3', label: '更新时间降序', description: 'edittime DESC' },
        { value: '选项4', label: '更新时间升序', description: 'edittime ASC' },
        { value: '选项5', label: '浏览次数降序', description: 'hits DESC' },
        { value: '选项6', label: '浏览次数升序', description: 'hits ASC' },
        { value: '选项7', label: '信息ID降序', description: 'id DESC' },
        { value: '选项8', label: '信息ID升序', description: 'id ASC' }
      ],
      member_data: [
        { value: '选项1', label: '注册时间降序', description: 'regtime DESC' },
        { value: '选项2', label: '注册时间升序', description: 'regtime ASC' },
        { value: '选项7', label: '信息ID降序', description: 'id DESC' },
        { value: '选项8', label: '信息ID升序', description: 'id ASC' }
      ],
      //日期方式排序选项
      time_data: [
        { value: 'edittime', label: '更新日期' },
        { value: 'addtime', label: '发布日期' }
      ],
      //所属国家选项
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ]
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 47,
        _exp: `companyid = ${this.updataID}`
      }
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        ret.forEach((item) =>
        {
          temp.push({
            id: item.id,
            title: item.title,
            content: item.content,
            thumb: item.thumb ? item.thumb : 'static/images/moren.jpg',
            authority: item.authority,
            fromtime: item.fromtime,
            totime: item.totime
          })
          this.tableData = temp
        })
      })
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/QyzsZzlbUpdata', query: {id: row.id}})
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/xsyz/QyzsZzlb.vue